/*

    Global popup settings

    enabled_on (array)
        Url path, popup will show on each specified page

    timer (boolean|number)
        If specified popup will show after X amount of time, provide value in miliseconds

    scroll_percent (boolean|number)
        If specified popup will show after X scroll from the top of the page

    outisde_close (boolean)
        If true popup will close after click on outside background

 */
module.exports = function () {
    return {
        frontend_config: [
            {
                magazine: {
                    title: "Free Ibiza tips Magazine",
                    subtitle: "New restaurants, hidden gems, the chillest beaches and more.",
                    image_title: "FREE IBIZA MAGAZINE",
                    enabled_on: [
                        "/services/*",
                        "/ibiza-information/beach-clubs/*",
                        "/ibiza-information/clubs/*",
                        "/blog/*",
                        "/ibiza-information/markets/",
                        "/ibiza-information/destinations/",
                        "/ibiza-information/where-to-go/",
                        "/ibiza-information/practical-info/",
                        "/ibiza-information/useful-phone-numbers/",
                        "/ibiza-information/ibiza-with-kids/",
                        "/ibiza-supermarkets/",
                        "/ibiza-information/golfing-in-ibiza/"
                    ],
                    timer: 1500,
                    scroll_percent: false,
                    outside_close: true,
                    magazine_type: "generic"    // magazine types: generic, restaurant, beach
                }
            },
            {
                beachesMagazine: {
                    title: "Our favourite Ibiza beaches",
                    subtitle: "Hip jetset beaches or hidden cozy gems. We are the local experts.",
                    image_title: "BEACHES MAGAZINE",
                    enabled_on: [
                        "/ibiza-information/beaches/*",
                    ],
                    timer: 1500,
                    scroll_percent: false,
                    outside_close: true,
                    magazine_type: "beach"    // magazine types: generic, restaurant, beach
                }
            },
            {
                restaurantsMagazine: {
                    title: "Our favourite Ibiza restaurants",
                    subtitle: "New restaurants, hidden gems, the chillest beaches and more.",
                    image_title: "RESTAURANTS MAGAZINE",
                    enabled_on: [
                        "/ibiza-information/restaurants/*",
                    ],
                    timer: 1500,
                    scroll_percent: false,
                    outside_close: true,
                    magazine_type: "restaurant"    // magazine types: generic, restaurant, beach
                }
            }
        ],
    }
};